import { render, staticRenderFns } from "./vip-wbook.vue?vue&type=template&id=1f6c2296&scoped=true&"
import script from "./vip-wbook.vue?vue&type=script&lang=js&"
export * from "./vip-wbook.vue?vue&type=script&lang=js&"
import style0 from "./vip-wbook.vue?vue&type=style&index=0&id=1f6c2296&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6c2296",
  null
  
)

export default component.exports